module.exports = __webpack_public_path__ + "static/map_usa_MW-6ef2183d4e055944d84340a5e8c6a511.png";